// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3831fc18","769":"02e8ef6e"}[chunkId] + ".chunk.js";
};